import * as Session from './Login'
import * as ComponentsPassword from './Password'

export const Login = Session.Login;
export const ForgotPassword = ComponentsPassword.ForgotPassword;
export const SendEmailPassword = ComponentsPassword.SendEmailPassword;
export const ChangePasswordFromEmail = ComponentsPassword.ChangePasswordFromEmail;
export const SuccessChangePasswordFromEmail = ComponentsPassword.SuccessChangePasswordFromEmail;
export const ChangePasswordFromUser = ComponentsPassword.ChangePasswordFromUser;
export const SuccessChangePasswordFromUser = ComponentsPassword.SuccessChangePasswordFromUser;